<template>
  <div class="g-flex g-item-center">
    <div>
      <input
        class="focus:g-outline-none g-border g-border-r-0 g-border-grey-200 g-w-16 g-h-full g-pr-4 g-text-right"
        type="text"
        :value="value"
        @input="changeValue($event.target.value)"
      />
    </div>

    <div class="g-flex g-flex-col">
      <button class="g-text-bold g-text-xs g-bg-grey-100 g-text-grey-800 g-py-1 g-px-2 g-border g-border-grey-200" @click="increment">
        <gp-icon
          :icon="['fas', 'plus']"
          size="xs"
          :style="{
            cursor: 'pointer',
            transform: 'scale(1.3)',
          }"
        />
      </button>
      <button class="g-text-bold g-text-xs g-bg-grey-100 g-text-grey-800 g-py-1 g-px-2 g-border g-border-grey-200" @click="decrement">
        <gp-icon
          :icon="['fas', 'minus']"
          size="xs"
          :style="{
            cursor: 'pointer',
            transform: 'scale(1.3)',
          }"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuantityInput",

  props: ["stepSize", "allowDecimal", "quantity"],

  data() {
    return {
      value: 0,
    };
  },

  created() {
    if (this.quantity) this.value = this.quantity;
  },

  methods: {
    changeValue(value) {
      let newValue = Math.abs(Number(String(value).replace(",", ".")));

      // Convert number to string, if there are more than 2 decimals cut off the rest
      let decimals = ("" + newValue).split(".")[1];

      if (decimals) {
        decimals = decimals.slice(0, 2);
        newValue = Number(("" + newValue).split(".")[0] + "." + decimals);
        this.value = null; // reset value to null to force re-render
      }

      if (!this.allowDecimal) {
        newValue = Math.floor(newValue);
        this.value = null; // reset value to null to force re-render
      }

      this.$emit("change", newValue);

      this.value = newValue;
    },

    increment() {
      let newValue = Number(this.value) + Number(this.stepSize || 1);
      this.changeValue(newValue.toFixed(2));
    },

    decrement() {
      let newValue = Number(this.value) - Number(this.stepSize || 1);
      if (newValue <= 0) return this.changeValue(0);

      this.changeValue(newValue);
    },
  },

  watch: {
    quantity(newQuantity) {
      this.changeValue(newQuantity);
    },
  },
};
</script>

<style lang="scss" scoped></style>
